import { type RefObject, useEffect } from "react";

interface UseScrollToViewOnViewportResizeOptions {
  isEnabled: boolean;
  delayInMs: number;
  behavior?: ScrollBehavior;
  block?: ScrollLogicalPosition;
}

export function useScrollToViewOnViewportResize(
  elementRef: RefObject<HTMLElement | undefined>,
  options: UseScrollToViewOnViewportResizeOptions
) {
  const { isEnabled, delayInMs, behavior = "smooth", block = "start" } = options;

  useEffect(() => {
    if (!isEnabled) {
      return undefined;
    }

    let debounceTimer: ReturnType<typeof setTimeout>;

    function handleViewportResize() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (elementRef.current && document.activeElement instanceof HTMLInputElement) {
          elementRef.current.scrollIntoView({ behavior, block });
        }
      }, delayInMs);
    }

    window.visualViewport?.addEventListener("resize", handleViewportResize);

    return () => {
      clearTimeout(debounceTimer);
      window.visualViewport?.removeEventListener("resize", handleViewportResize);
    };
  }, [isEnabled, elementRef, delayInMs, behavior, block]);
}
